import { LitElement, html, css } from 'lit-element';
import { Theme } from '@furo/framework/src/theme.js';
import { FBP } from '@furo/fbp';
import './arbeitsausgaben-list.js';
import './arbeitsausgaben-detail.js';
/**
 * `view-s-ausgaben`
 * todo Describe your element
 *
 * @summary todo shortdescription
 * @customElement
 * @demo demo-view-s-ausgaben
 * @appliesMixin FBP
 */
class ViewSAusgaben extends FBP(LitElement) {
  /**
   * flow is ready lifecycle method
   */
  _FBPReady() {
    super._FBPReady();
    // this._FBPTraceWires()
  }

  /**
   * Themable Styles
   * @private
   * @return {CSSResult}
   */
  static get styles() {
    // language=CSS
    return (
      Theme.getThemeForComponent('ViewSAusgaben') ||
      css`
        :host {
          display: block;
        }

        :host([hidden]) {
          display: none;
        }

        furo-app-bar-top {
          height: 48px;
        }
      `
    );
  }

  /**
   * @private
   * @returns {TemplateResult}
   * @private
   */
  render() {
    // language=HTML
    return html`
      <furo-vertical-flex>
        <furo-app-bar-top drawer="arbeitsausgaben">
          <objekt-menu flex page-name="s-ausgaben" ƒ-refresh="--pageActivated"></objekt-menu>
        </furo-app-bar-top>
        <furo-app-drawer name="arbeitsausgaben" float-breakpoint="1020">
          <arbeitsausgaben-list
            slot="drawer"
            drawer="arbeitsausgaben"
            @-item-clicked="--listItemclicked"
            @-add-time-clicked="--addClicked"
            ƒ-set-qp="--pageActivated(*.query)"
            ƒ-reload-list="--ausgabeChanged, --ausgabeCreated"
          ></arbeitsausgaben-list>


          <arbeitsausgaben-detail
            ƒ-set-qp="--locationChanged(*.query)"
            ƒ-add-clicked="--addClicked"
            @-ausgabe-created="--ausgabeCreated"
            @-ausgabe-saved="--ausgabeChanged"
            @-ausgabe-deleted="--ausgabeChanged, --ausgabeDeletedQP"
          ></arbeitsausgaben-detail>

      </furo-vertical-flex>
      </furo-app-drawer>

      <!-- wir hören auf die URL -->
      <furo-location
        url-space-regex="${window.APPROOT}/s-ausgaben"
        @-location-changed="--locationChanged"
      ></furo-location>

      <!-- addClicked gibt uns einen HTS rein und wir kriegen die qp -->
      <furo-reverse-deep-link
        service="Arbeitsausgabe"
        rel="list" @-converted="--addQp"
        ƒ-convert="--addClicked"
      ></furo-reverse-deep-link>

      <furo-reverse-deep-link
        service="Arbeitsausgabe"
        rel="self" @-converted="--itemQp"
        ƒ-convert="--listItemclicked(*.links)"
      ></furo-reverse-deep-link>

      <!-- wir schreiben die QP in die URL -->
      <furo-qp-changer clear="sco,ara" ƒ-set-qp="--itemQp,--addQp,--ausgabeDeletedQP"></furo-qp-changer>
      `;
  }
}

window.customElements.define('view-s-ausgaben', ViewSAusgaben);
